<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color: white; font-weight: bold">
          Produto 
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-toolbar color="white" dark>
        <v-btn @click="close" class="primary">X</v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title style="color: #1da89b; font-weight: bold">
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save">
          <span v-show="!saving">Salvar</span>
          <v-progress-circular
            v-show="saving"
            indeterminate
            color="white"
          ></v-progress-circular
        ></v-btn>
      </v-toolbar>

      <v-card class="ma-0">
        <v-container style="max-width: 90%">
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                :disabled="true"
                label="Tipo"
                hide-details="auto"
                v-model="device.deviceType"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Código"
                hide-details="auto"
                v-model="device.code"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Descrição"
                hide-details="auto"
                v-model="device.description"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Fabricante"
                hide-details="auto"
                v-model="device.manufacturer"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="device.product">
            <v-col cols="12" md="2">
              <vuetify-money
                v-model.number="device.product.cost"
                label="Custo"
                v-bind:options="$globalFunctions.optionsMoneyBr"
              />
            </v-col>

            
            <v-col cols="12" md="2">
              <vuetify-money
                v-model.number="device.product.priceTarget"
                label="Preço target"
                v-bind:options="$globalFunctions.optionsMoneyBr"
              />
            </v-col>

            <v-col cols="12" md="2">
              <v-switch
                v-model="device.product.available"
                label="Disponível"
              ></v-switch>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Unidade"
                hide-details="auto"
                v-model="device.unit"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                label="Fornecedor"
                hide-details="auto"
                v-model="device.product.sellerId"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                label="Código CRM"
                hide-details="auto"
                v-model="device.product.crmId"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                label="Código ERP"
                hide-details="auto"
                v-model="device.product.erpId"
              ></v-text-field>
            </v-col>
                <v-col cols="12" md="3">
            <vuetify-money
              v-model.number="device.warranty"
              label="Garantia (anos)"
              v-bind:options="$globalFunctions.optionsInteger"
            />
          </v-col>
          </v-row>
          <edit-inverter
            v-if="device.deviceType == 'inverter'"
            v-bind:device="device"
          ></edit-inverter>
          <edit-module
            v-if="device.deviceType == 'module'"
            v-bind:device="device"
          ></edit-module>
          <edit-stringbox
            v-if="device.deviceType == 'stringbox'"
            v-bind:device="device"
          ></edit-stringbox>
          <edit-connector
            v-if="device.deviceType == 'connector'"
            v-bind:device="device"
          ></edit-connector>
          <edit-cable
            v-if="device.deviceType == 'cable'"
            v-bind:device="device"
          ></edit-cable>
          <edit-transformer
            v-if="device.deviceType == 'transformer'"
            v-bind:device="device"
          ></edit-transformer>

          <edit-accessory
            v-if="device.deviceType == 'accessory'"
            v-bind:device="device"
          ></edit-accessory>

          <edit-rail
            v-if="device.deviceType == 'rail'"
            v-bind:device="device"
          ></edit-rail>

          <edit-structure
            v-if="device.deviceType == 'structure'"
            v-bind:device="device"
          ></edit-structure>

          <edit-service
            v-if="device.deviceType == 'service'"
            v-bind:device="device"
          ></edit-service>

          <edit-generator
           @dcPowerChanged = "dcPowerChanged"
            v-if="device.deviceType == 'generator'"
            v-bind:device="device"
          ></edit-generator>
          
        </v-container>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
//EditInverter
//import { EditInverter,EditModule } from "@/components";

import Inverter from "@/libraries/classes/devices/Inverter.js";
import Module from "@/libraries/classes/devices/Module.js";
import _ from "lodash";
import EditInverter from "../../components/devices/EditInverter.vue";
import EditModule from "../../components/devices/EditModule.vue";
import EditStringbox from "../../components/devices/EditStringbox.vue";
import EditConnector from "../../components/devices/EditConnector.vue";
import EditCable from "../../components/devices/EditCable.vue";
import EditTransformer from "../../components/devices/EditTransformer.vue";
import EditAccessory from "../../components/devices/EditAccessory.vue";
import EditRail from "../../components/devices/EditRail.vue";
import EditStructure from "../../components/devices/EditStructure.vue";
import EditService from "../../components/devices/EditService.vue";
import EditGenerator from "../../components/devices/EditGenerator.vue";
import hebelApi from '../../../../libraries/hebel/hebelApi';


// import EditStringbox from '../../components/Devices/EditStringbox.vue';
// import EditCable from '../../components/Devices/EditCable.vue';
// import EditConnector from '../../components/Devices/EditConnector.vue';
// import EditTransformer from '../../components/Devices/EditTransformer.vue';
// import EditAccessory from '../../components/Devices/EditAccessory.vue';
// import EditRail from '../../components/Devices/EditRail.vue';
// import EditStructure from '../../components/Devices/EditStructure.vue';

export default {
  name: "Device",
  props: ["deviceId"],
  components: {
    EditInverter,
    EditModule,
    EditStringbox,
    EditConnector, // EditModule,
    EditTransformer,
    EditCable, // EditStringbox,
    EditAccessory,
    EditRail,
    EditStructure, // EditCable,
    EditService,
    EditGenerator
  
  },
  data() {
    return {
      filePath:"",
      value: "1234567.89",
      label: "Value",
      placeholder: " ",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: true,
      valueWhenIsEmpty: "",
      test: false,
      available: false,
      device: { product: { cost: 0, price: 0, available: false } },
      saving: false,
    };
  },
  created() {
    //alert("created")
  },

  async mounted() {
    // alert("mounted2:" + this.deviceId)

    if (!this.deviceId) {
      this.device = this.$session.get("newDevice");
      return;
    }
    //alert("edit device:" + this.deviceId)
    //var devices = await this.$dao.getDevice(window.eid, this.deviceId);
    var devices = await hebelApi.devices.getFromId(this.deviceId);

    this.device = devices[0];
    if (this.device.product === undefined)
      this.device.product = {
        cost: 0,
        price: 0,
        available: false,
        sellerId: "",
      };

    if (this.device.deviceType == "module") {
      this.device.dcPowerWp = this.device.dcPower * 1000;
    }

    this.$forceUpdate();
  },
  methods: {
    dcPowerChanged(){
      //alert("dcPowerChanged")
     // this.product.
    },
    async close() {
      //this.$router.push("/devices")
      //alert("will close")
      this.$router.push("/devices");
    },

    async save() {
      console.log("save");
      this.saving = true;
      if (this.device.deviceType == "module") {
        this.device.dcPower = this.device.dcPowerWp / 1000;
      }

      //var d = await this.$dao.upsertDevice(this.device, window.eid);
      var d = await hebelApi.devices.upsert(this.device);
      
      console.log("saved" + d.id);
      this.device.id = d.id;
      this.saving = false;
      this.$router.push("/devices");
    },
    update() {
      //  alert("update")
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
/* 
    loadTags(){

        const ref = this.$firebase.database().ref("/tags");//.orderByChild('createdAt').startAt(1602471600000).endAt(1602471600001);
        ref.once('value', snapshot => {
            const values = snapshot.val()
            this.tags = values;
            this.tagsArray = Object.keys(values).map(i => values[i])
        })
    }, */
</style>